export default __webpack_public_path__ + "static/media/outgoing-warning.b2176313.svg";